const NameRoles = [
    /\bMHD\b/i,      // should not  "MHD" with any capitalization
    /\bDr\b/i,   // should not  "Dr" with any capitalization as a whole word
    /\bMs\b/i,   // should not  "Ms" with any capitalization as a whole word
    /\bPhD\b/i,  // should not  "PhD" with any capitalization as a whole word
    /\bEng\b/i,  // should not  "Eng" with any capitalization as a whole word
    /[A-Z]{2,}/, // should not  two or more consecutive capital letters
    /^[a-z]+$/ , // should not be only small letter
  ];
  export default NameRoles ;